export const environment = {
  production: false,
  authApiUrl: process.env.REACT_APP_AUTH_API,
  partnerApiUrl: process.env.REACT_APP_PARTNER_API,
  userApiUrl: process.env.REACT_APP_USER_API,
 invoiceApiUrl: process.env.REACT_APP_INVOICE_API,
 creatorRegisterUrl: process.env.REACT_APP_PATNER_PORTAL_CREATOR_REGISTER,
 quoteApiUrl: process.env.REACT_APP_QUOTE_API
};
